import Skeleton from 'react-loading-skeleton'

const DeliveryHeaderSkeleton = () => (
  <div className='mb-4'>
    <Skeleton width={200} height={32} />
  </div>
)

export default DeliveryHeaderSkeleton
